import { defineMessages } from 'react-intl-next';
export const contextPanelMessages = defineMessages({
	panelLabel: {
		id: 'fabric.editor.contextPanel.panelLabel',
		defaultMessage: 'Context panel',
		description: 'Label for the context panel',
	},
	panelContentLabel: {
		id: 'fabric.editor.contextPanel.panelContentLabel',
		defaultMessage: 'Scrollable context panel content',
		description: 'Label for the context panel content',
	},
});
